import React from 'react';

import { Text } from '@thefarmersfront/kitchen';

import type { CustomCellRendererProps } from 'ag-grid-react';

import type { TypeReceiveRequestsInfo, TypeReceiveStatusInfo } from '~/types/receive.types';

import styles from './ReceiveSupplierCell.module.scss';

/**
 * [입고관리] 공급사, 공급사코드 셀 렌더러
 * @example '(주)홍길동식품 공급업체 SU12345'
 */
const ReceiveSupplierCell = <TData extends TypeReceiveRequestsInfo | TypeReceiveStatusInfo>({
  data,
}: CustomCellRendererProps<TData>) => {
  if (!data) return '-';

  return (
    <div className={styles['supplier-supplier-code-cell']}>
      <Text className={styles['supplier-name']} size="large">
        {data.supplierName}
      </Text>
      <Text className={styles['supplier-code']} size="large" color="quaternary">
        {data.supplierCode}
      </Text>
    </div>
  );
};

export default ReceiveSupplierCell;
